<script>
  import Icon from './Icons.svelte'; // Adjust the import path as necessary
  export let url = '';
  export let title = '';
  export let text = '';

  async function shareContent(event) {
    event.preventDefault(); // Prevent the link from navigating
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url,
        });
        console.log('Content shared successfully');
      } catch (err) {
        console.error('Error sharing the content', err);
      }
    } else {
      console.log('Web Share API is not supported in this browser.');
      // Implement fallback logic here
    }
  }
</script>

<a href="#" on:click={shareContent} rel="noopener noreferrer">
  <span class="icon-container">
    <Icon name="Icon-share" class="icon__article-icon" />
  </span>
</a>
